import { memo, type MutableRefObject } from "react";

import ChatInputBar from "@/features/tutor/components/ChatInputBar";
import ConversationWindow from "@/features/tutor/components/ConversationWindow";
import { useChatSettingsStore } from "@/features/tutor/store/useChatSettingsStore";
import type { SendResult } from "@/features/tutor/hooks/useSendChatMessage";
import type { ComposerDraft } from "@/features/tutor/hooks/useMathComposer";
import { CONTROL_BAR_WIDTH } from "@/features/tutor/constants/controlBar";

const ChatSurface = ({
  onSend,
  draft,
}: {
  onSend: (text: string) => Promise<SendResult>;
  draft?: MutableRefObject<ComposerDraft | null>;
}) => {
  const windowOpen = useChatSettingsStore((s) => s.chatWindowOpen);
  const setChatWindowOpen = useChatSettingsStore((s) => s.setChatWindowOpen);

  return (
    <div className={`flex ${CONTROL_BAR_WIDTH} flex-col items-stretch`}>
      {windowOpen && (
        <div className="mb-2.5">
          <ConversationWindow onClose={() => setChatWindowOpen(false)} />
        </div>
      )}
      <ChatInputBar
        onSend={onSend}
        windowOpen={windowOpen}
        onToggleWindow={() => setChatWindowOpen(!windowOpen)}
        draft={draft}
      />
    </div>
  );
};

export default memo(ChatSurface);
